<template>
  <label class="nft-btnbar-item" :class="{'disabled': disabled}">
    <span class="nft-btnbar-label">{{ label }}</span>
    <button
        type="button"
        class="btn btn-btnbar"
        :class="{ active: isActive, ['btn-' + variant]: true }"
        @click="$emit('click')"
        :disabled="disabled"
    >
      <img v-if="iconSrc" alt="Ficha médica" :src="iconSrc"/>
      <slot v-else/>
    </button>
  </label>
</template>

<script>
  export default {
    name: 'ButtonBarItem',
    props: {
      contentRef: {
        type: Number,
      },
      label: {
        type: String,
        default: '',
      },
      variant: {
        type: String,
        default: 'info',
      },
      isActive: {
        type: Boolean,
        default: false,
      },
      iconSrc: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
  }
</script>

<style scoped lang="scss">
  .nft-btnbar-item {
    display: flex;
    align-items: center;
    transition: transform 150ms;
    margin-top: $btnbar-item-margin-y;
    margin-bottom: $btnbar-item-margin-y;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    & .nft-btnbar-label {
      opacity: 0;
      padding: 0.4rem 0.5rem;
      position: absolute;
      font-size: $font-size-sm;
      text-align: left;
      line-height: 1.2em;
      right: 2rem;
      transition: right 150ms, opacity 150ms;
      pointer-events: none;
      background-color: white;
      border-radius: 0.55rem;
      z-index: -1;
    }

    &:hover .nft-btnbar-label {
      opacity: 1;
      right: 3.5rem;
      box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.1);
    }

    &.disabled:hover .nft-btnbar-label {
      opacity: 0.5;
    }

    & .btn-btnbar {
      width: $btnbar-btn-size;
      height: $btnbar-btn-size;
      line-height: 0;
      border-radius: 50%;
      padding: 0.4rem;
      box-shadow: 0 0.2rem 0.4rem rgba(25, 49, 97, 0.2);
      overflow: hidden;

      & img {
        width: 100%;
        height: 100%;
      }
      
      &:disabled {
        cursor: default !important;
      }
    }

    &:hover:not(.disabled) {
      transform: scale(1.2);
    }
  }
</style>